import { FC, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { DateTime } from "luxon";
import { Formik } from "formik";
import { t } from "i18next";

import TableListUsersActivitys from "@/shared/components/organisms/TableListUsersActivitys";
import { InputWithCornerHint } from "@/shared/components/atoms/InputWithCornerHint";
import TableListFestivos from "@/shared/components/organisms/TableListFestivos";
import { FiltersCalendar } from "@/shared/components/organisms/FiltersCalendar";
import TableListGrupos from "@/shared/components/organisms/TableListGrupos";
import TableListSalas from "@/shared/components/organisms/TableListSalas";
import { DialogCreate } from "@/shared/components/molecules/DialogCreate";
import { SelectAvatar } from "@/shared/components/organisms/SelectAvatar";
import { MultiSelect } from "@/shared/components/organisms/MultiSelect";
import { DateRangePicker } from "@/shared/components/atoms/DataRangePicker";
import { SelectColor } from "@/shared/components/organisms/SelectColor";
import { CheckBoxDays } from "@/shared/components/atoms/CheckBoxDays";
import { InputFilepdf } from "@/shared/components/atoms/InputFilePDF";
import { Calendar } from "@/shared/components/organisms/Calendar";
import { ModalXXL } from "@/shared/components/organisms/ModalXXL";
import { InputFile } from "@/shared/components/atoms/InputFile";
import { Select } from "@/shared/components/organisms/Select";
import * as Yup from "yup";
import { selectBranch } from "@/app/branchs/branch.slice";

import {
  useCreateLessonMutation,
  useDeleteLessonMutation,
  useLessonGroupsQuery,
  useUpdateLessonMutation,
  useLessonsQuery,
  useUpdateLessonsGroupMutation,
  useStoreFileMutation,
  useEnrollLessonMutation,
} from "@/app/lessons/lessons.api";
import {
  useRoomsQuery,
  useCreateRoomMutation,
  useDeleteRoomMutation,
  useUpdateRoomMutation,
} from "@/app/rooms/rooms.api";
import {
  useCreateHolidayMutation,
  useDeleteHolidayMutation,
  useHolidaysQuery,
  useUpdateHolidayMutation,
} from "@/app/holidays/holidays.api";
import { useFeesMutation } from "@/app/fees/fees.api";
import { useSpecialistsQuery } from "@/app/branchs/branchs.api";

import { BaseEvent } from "@/app/events/events";
import {
  holidaysInitialValues,
  holidaysValidationSchema,
  LessonTimesValues,
  lessonInitialValues,
  lessonValidationSchema,
  lessonTimesInitialValues,
  lessonTimesValidationSchema,
  lessonsCalendarInitialValues,
  lesssonsCalendarValidationSchema,
} from "@/shared/schemas/lessons.schema";
import { colors } from "@/app/fees/fees";
import {
  CreateRoomValues,
  createRoomInitialValues,
  createRoomValidationSchema,
} from "@/shared/schemas/rooms.schema";
import { toasts } from "@/shared/utils/toasts";

import { useUpdateHoursMutation } from "@/app/branchs/branchs.api";
import { DOMAIN } from "@/app/app.api";
import { Modal } from "@/shared/components/organisms/Modal";
import { Input } from "@/shared/components/atoms/Input";
import { InputWithSelectHint } from "@/shared/components/atoms/InputWithSelectHint";
import { useFetchUsersMutation } from "@/app/users/users.api";
import { useFunctionDebounce } from "@/shared/hooks/debounce";
import { FIELD_REQUIRED_MESSAGE } from "@/shared/utils/validations";
import AlertWarningButtons from "@/shared/components/molecules/AlertWarningButtons";
import { Permission, usePermission } from "@/shared/hooks/usePermission";

const optionSelectFestivos = [
  { id: "Local", name: "Local" },
  { id: "Provincial", name: "Provincial" },
  { id: "Nacional", name: "Nacional" },
  { id: "Mundial", name: "Mundial" },
];

export const DirectedActivities: FC<any> = () => {
  const { id } = useParams();
  const { can } = usePermission();
  const [month, setMonth] = useState(DateTime.now().toFormat("yyyy-MM"));
  const [currentGroupEdit, setCurrentGroupEdit] = useState();
  const [currentRoomEdit, setCurrentRoomEdit] = useState();
  const [currentEventEdit, setCurrentEventEdit] = useState<
    BaseEvent | undefined
  >();
  const [checkAllEvents, setCheckAllEvents] = useState(false);
  const [currentEvent, setCurrentEvent] = useState<BaseEvent | undefined>();
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [
    showModalWarningCreateLessonForce,
    setShowModalWarningCreateLessonForce,
  ] = useState<boolean>(false);
  const [valuesCreateLessonForce, setValuesCreateLessonForce] = useState<any>();

  const branch = useSelector(selectBranch);
  const [fetchUsers] = useFetchUsersMutation();
  const [lessonTimesValues, setLessonTimesValues] = useState({
    type: "lessons",
    hours: 0,
    days_access: 0,
    time_access: 0,
  });

  const [users, setUsers] = useState([]);
  const debouncedFetchDataUsers = useFunctionDebounce(fetchDataUsers, 300);
  //Fetch data users
  async function fetchDataUsers(search: string) {
    try {
      const response = await fetchUsers({
        search: search.length < 1 ? undefined : search,
        page: 1,
        limit: 20,
        branch: id,
      }).unwrap();

      const arrayUsers = [];
      let objetCompanies = {};

      for (let i = 0; i < response.data.length; i++) {
        objetCompanies = {
          id: response.data[i].id,
          name: response.data[i].name,
          email: response.data[i].email,
        };
        arrayUsers.push(objetCompanies);
      }
      setUsers(arrayUsers);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (branch) {
      setLessonTimesValues({
        ...lessonTimesValues,
        hours: branch.cancellation_lessons,
        days_access: branch.days_access,
        time_access: branch.time_access,
      });
    }
  }, [branch]);

  const [updateBranchHours, updateBranchHourssResult] =
    useUpdateHoursMutation();

  useEffect(() => {
    if (updateBranchHourssResult.isSuccess) {
      toasts.success(
        "Actualización exitosa",
        "Los tiempos se han actualizado correctamente"
      );
    }
    if (updateBranchHourssResult.isError) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar los tiempos"
      );
    }
  }, [updateBranchHourssResult]);

  const [storeCalendarFile, storeCalendarFileResult] = useStoreFileMutation();

  useEffect(() => {
    if (storeCalendarFileResult.isSuccess) {
      toasts.success(
        "Carga exitosa",
        "El calendario se ha cagado exitosamente"
      );
    }
    if (storeCalendarFileResult.isError) {
      toasts.danger("Error al cargar", "No se ha podido cargar el documento");
    }
  }, [storeCalendarFileResult]);

  const roomsQuery = useRoomsQuery({ branchId: id });
  const [createRoom, createRoomResult] = useCreateRoomMutation();
  const [updateRoom, updateRoomResult] = useUpdateRoomMutation();
  const [deleteRoom] = useDeleteRoomMutation();

  const lessonsQuery = useLessonsQuery({
    branchId: id,
    groups: selectedGroups?.map((group) => group.name) || [],
    month: month,
  });

  const [createLesson, createLessonResult] = useCreateLessonMutation();
  const [enrollUserLesson, enrollUserLessonResult] = useEnrollLessonMutation();
  const [updateLesson, updateLessonResult] = useUpdateLessonMutation();
  const [deleteLesson, deleteLessonResult] = useDeleteLessonMutation();

  const holidaysQuery = useHolidaysQuery({ branchId: id });
  const [currentHolidayEdit, setCurrentHolidayEdit] = useState<any>();
  const [createHoliday, createHolidayResult] = useCreateHolidayMutation();
  const [updateHoliday, updateHolidayResult] = useUpdateHolidayMutation();
  const [deleteHoliday, deleteHolidayResult] = useDeleteHolidayMutation();

  useEffect(() => {
    if (createHolidayResult.isSuccess) {
      toasts.success(
        "Festivo creado",
        "El festivo se ha registrado correctamente"
      );
      setOpenDialogFestivos(false);
    }
    if (createHolidayResult.isError) {
      toasts.danger(
        "Error al crear",
        "Ha ocurrido un problema al registrar el festivo"
      );
    }
  }, [createHolidayResult]);

  useEffect(() => {
    if (updateHolidayResult.isSuccess) {
      toasts.success(
        "Festivo actualizado",
        "El festivo se ha actualizado correctamente"
      );
      setOpenDialogFestivos(!openDialogFestivos);
    }
    if (updateHolidayResult.isError) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un problema al actualizar el festivo"
      );
    }
  }, [updateHolidayResult]);

  useEffect(() => {
    if (deleteHolidayResult.isSuccess) {
      toasts.success(
        "Festivo eliminado",
        "El festivo se ha eliminado correctamente"
      );
      setCurrentHolidayEdit(null);
    }
    if (deleteHolidayResult.isError) {
      toasts.danger(
        "Error al eliminar",
        "Ha ocurrido un error al eliminar el festivo"
      );
    }
  }, [deleteHolidayResult]);

  useEffect(() => {
    if (currentHolidayEdit) {
      setOpenDialogFestivos(true);
    }
  }, [currentHolidayEdit]);

  const lessonGroupsQuery = useLessonGroupsQuery({ branchId: id });
  const [updateLessonsGroup, updateLessonsGroupResult] =
    useUpdateLessonsGroupMutation();
  const [getterFees, getterFeesResult] = useFeesMutation();
  const specialistsQuery = useSpecialistsQuery({ branchId: id });

  useEffect(() => {
    if (id) {
      getterFees({
        branchId: id,
      });
    }
  }, [id]);

  useEffect(() => {
    if (createLessonResult.isSuccess) {
      setOpenDialogCreate(false);
      createLessonResult.reset();
    }
  }, [createLessonResult]);

  useEffect(() => {
    if (deleteLessonResult.isSuccess) {
      setCurrentEvent(undefined);
    }
  }, [deleteLessonResult]);

  useEffect(() => {
    if (createRoomResult.isSuccess) {
      toasts.success(
        "Sala registrada",
        "La sala se ha registrado correctamente"
      );
      setOpenDialogSala(false);
    }
    if (createRoomResult.isError) {
      toasts.danger(
        "Error al registrar",
        "Ha ocurrido un error al registrar la sala"
      );
    }
  }, [createRoomResult]);

  useEffect(() => {
    if (updateRoomResult.isSuccess) {
      toasts.success(
        "Actualización exitosa",
        "La sala se ha actualizado correctamente"
      );
      setOpenDialogSala(false);
    }
    if (updateRoomResult.isError) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar la sala"
      );
    }
  }, [updateRoomResult]);

  useEffect(() => {
    setOpenDialogSala(!!currentRoomEdit);
  }, [currentRoomEdit]);

  const handleEventClick = (event: BaseEvent) => {
    setCurrentEvent(event);
  };

  //OPEN FOR FILTERS
  const [filters, setFilters] = useState(false);
  const filtersOpen = () => {
    setFilters(!filters);
  };
  //OPEN DIALOG CREATE
  const [openDialogCreate, setOpenDialogCreate] = useState(false);
  const functionOpenDialogCreate = () => {
    setOpenDialogCreate(!openDialogCreate);
    setCurrentEventEdit(undefined);
  };

  //OPEN DIALOG TIEMPOS
  const [openDialogTime, setOpenDialogTime] = useState(false);
  const functionOpenDialogTime = () => {
    setOpenDialogTime(!openDialogTime);
  };
  //OPEN DIALOG UPCALENDAR
  const [openDialogUpCalendar, setOpenDialogUpCalendar] = useState(false);
  const functionOpenDialogUpCalendar = () => {
    setOpenDialogUpCalendar(!openDialogUpCalendar);
  };
  //OPEN MODAL FESTIVOS
  const [openModalFestivos, setOpenModalFestivos] = useState(false);
  const functionOpenModalFestivos = () => {
    setOpenModalFestivos(!openModalFestivos);
  };
  //OPEN DIALOG FESTIVOS
  const [openDialogFestivos, setOpenDialogFestivos] = useState(false);
  const functionOpenDialogFestivos = () => {
    setOpenDialogFestivos(!openDialogFestivos);
  };
  //OPEN MODAL SALAS
  const [openModalSala, setOpenModalSala] = useState(false);
  const functionOpenModalSala = () => {
    setOpenModalSala(!openModalSala);
  };
  //OPEN DIALOG CREATE SALAS
  const [openDialogSala, setOpenDialogSala] = useState(false);
  const functionOpenDialogSala = () => {
    setOpenDialogSala(!openDialogSala);
  };
  //OPEN MODAL GRUPOS
  const [openModalGrupos, setOpenModalGrupos] = useState(false);
  const functionOpenModalGrupos = () => {
    setOpenModalGrupos(!openModalGrupos);
  };
  //OPEN DIALOG EDIT GRUPOS
  const [openDialogEditGrupos, setOpenDialogEditGrupos] = useState(false);
  const functionOpenDialogEditGrupos = () => {
    setOpenDialogEditGrupos(!openDialogEditGrupos);
  };
  //OPEN MODAL DELETE EVENT
  const [openModalDeleteEvent, setOpenModalDeleteEvent] = useState(false);
  const [deleteAllEvents, setDeleteAllEvents] = useState(false);
  const functionOpenModalDeleteEvent = () => {
    setOpenModalDeleteEvent(!openModalDeleteEvent);
  };

  const [openModalEnrollUserActivity, setOpenModalEnrollUserActivity] =
    useState(false);
  const functionOpenModalEnrollUserActivity = () => {
    setOpenModalEnrollUserActivity(!openModalEnrollUserActivity);
  };

  const handleDeleteLesson = async () => {
    try {
      if (currentEvent?.id) {
        await deleteLesson({
          branchId: id,
          id: currentEvent?.id,
          all: deleteAllEvents,
        });
        functionOpenModalDeleteEvent();
        setCurrentEvent(undefined);
        toasts.success(
          "Actividad eliminada",
          "La(s) actividad(es) se ha(n) eliminado correctamente"
        );
      }
    } catch (error) {
      toasts.danger(
        "Error al eliminar",
        "Ha ocurrido un error al eliminar la actividad"
      );
    }
  };

  const handleEnrollUserActivity = async (values: any) => {
    try {
      const response = await enrollUserLesson({
        lessonId: currentEvent?.id,
        userId: values.user,
        allEvent: checkAllEvents,
      }).unwrap();

      if (response.error) {
        throw response.error;
      }

      setCurrentEvent(undefined);
      functionOpenModalEnrollUserActivity();
    } catch (error) {
      const message = error as string;

      if (message) {
        toasts.danger("Error al inscribir", message);
        throw error;
      }

      toasts.danger(
        "Error al inscribir",
        "Ha ocurrido un error al inscribir al usuario"
      );
      throw error;
    }
  };

  const handleUpdateLessonsGroup = async (values: any) => {
    try {
      await updateLessonsGroup({
        file: values.file,
        description: values.description,
        branchId: id,
        group: currentGroupEdit ? currentGroupEdit?.name : "",
        id: currentGroupEdit ? currentGroupEdit?.id : 0,
        color: currentGroupEdit ? currentGroupEdit.color : "",
      });
      setOpenDialogEditGrupos(false);
      toasts.success(
        "Grupo actualizado",
        "El grupo se ha actualizado correctamente"
      );
    } catch (error) {
      toasts.danger(
        "Error al actualizar",
        "Ha ocurrido un error al actualizar el grupo"
      );
      throw error;
    }
  };

  const handleCreateLessonForce = async () => {
    try {
      await createLesson(valuesCreateLessonForce).unwrap();
      toasts.success(
        "Registro exitoso",
        "La actividad se ha creado correctamente"
      );
      setValuesCreateLessonForce(undefined);
      setShowModalWarningCreateLessonForce(false);
      setCurrentEventEdit(undefined);
      functionOpenDialogCreate();
      lessonsQuery.refetch();
    } catch (error) {
      toasts.danger(
        "Error al crear",
        "Ha ocurrido un error al crear la actividad"
      );
      throw error;
    }
  };

  return (
    <div className="flex flex-col items-center h-full w-full p-2">
      <div className="flex flex-col w-full h-full">
        <Calendar
          loading={lessonsQuery.isLoading || lessonsQuery.isFetching}
          initialDateTime={DateTime.now()}
          events={lessonsQuery?.data ?? []}
          onEventClick={handleEventClick}
          functionButtonTime={functionOpenDialogTime}
          filtersOpen={filtersOpen}
          functionButtonTopCreate={functionOpenDialogCreate}
          functionButtonCalendar={functionOpenDialogUpCalendar}
          functionOpenModalFestivos={functionOpenModalFestivos}
          functionOpenModalSala={functionOpenModalSala}
          functionOpenModalGrupos={functionOpenModalGrupos}
          canCreateActivity={can(Permission.BRANCH_ACCESS_CREATE_ACTIVITY)}
          canEditTimesActivity={can(
            Permission.BRANCH_ACCESS_EDIT_TIMES_IN_ACTIVITIES
          )}
          canEditHolidaysActivity={can(
            Permission.BRANCH_ACCESS_EDIT_HOLIDAYS_IN_ACTIVITIES
          )}
          canUploadCalendar={can(Permission.BRANCH_ACCESS_UPLOAD_CALENDAR)}
          onMonthChange={(date) => {
            setMonth(date.toFormat("yyyy-MM"));
            lessonsQuery.refetch();
          }}
        />

        {/*DIALOG NUEVA ACTIVIDAD */}
        <Formik
          enableReinitialize
          validationSchema={lessonValidationSchema}
          initialValues={
            currentEventEdit
              ? {
                  name: currentEventEdit.name,
                  roomId: currentEventEdit.roomId,
                  userId: currentEventEdit.userId,
                  fees: currentEventEdit.fees,
                  capacity: currentEventEdit.capacity,
                  expectedAttendance: currentEventEdit.expectedAttendance,
                  duration: currentEventEdit.duration,
                  day: currentEventEdit.day,
                  days: currentEventEdit?.days?.map((day) => day),
                  color: currentEventEdit.color,
                  startDate: currentEventEdit.startDate,
                  endDate: currentEventEdit.endDate,
                  startTime: currentEventEdit.startTime,
                }
              : lessonInitialValues
          }
          validateOnMount
          validateOnBlur
          validateOnChange
          isInitialValid
          onSubmit={async (values, formikHelpers) => {
            try {
              // Ensure fees is always a string before submitting
              const feesValue = Array.isArray(values.fees)
                ? values.fees.join(",")
                : values.fees;

              if (currentEventEdit) {
                await updateLesson({
                  ...values,
                  fees: feesValue,
                  id: currentEventEdit.id,
                  branchId: id,
                }).unwrap();
                setCurrentEvent(undefined);
                toasts.success(
                  "Actualización exitosa",
                  "La actividad se ha actualizado correctamente"
                );
                lessonsQuery.refetch();
              } else {
                await createLesson({
                  ...values,
                  fees: feesValue,
                  branchId: id,
                  userId: values.userId,
                  roomId: values.roomId,
                  name: values.name,
                  startDate: values.startDate,
                  endDate: values.endDate,
                  startTime: values.startTime,
                  days: values.days,
                  color: values.color,
                  is_force: false,
                  capacity: values.capacity,
                  expectedAttendance: values.expectedAttendance,
                  duration: values.duration,
                }).unwrap();
                toasts.success(
                  "Registro exitoso",
                  "La actividad se ha creado correctamente"
                );
                lessonsQuery.refetch();
              }
              setCurrentEventEdit(undefined);
              formikHelpers.resetForm();
              functionOpenDialogCreate();
            } catch (error) {
              const messageFlag = error?.data?.message || undefined;
              if (messageFlag) {
                const feesValue = Array.isArray(values.fees)
                  ? values.fees.join(",")
                  : values.fees;

                setShowModalWarningCreateLessonForce(true);
                setValuesCreateLessonForce({
                  ...values,
                  fees: feesValue,
                  branchId: id,
                  userId: values.userId,
                  roomId: values.roomId,
                  name: values.name,
                  startDate: values.startDate,
                  endDate: values.endDate,
                  startTime: values.startTime,
                  days: values.days,
                  color: values.color,
                  is_force: true,
                  capacity: values.capacity,
                  expectedAttendance: values.expectedAttendance,
                  duration: values.duration,
                });
                formikHelpers.resetForm();
                functionOpenDialogCreate();
                return;
              }

              toasts.danger(
                "Error al crear",
                "Ha ocurrido un error al crear la actividad"
              );
            }
          }}
        >
          {({
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            handleSubmit,
            resetForm,
            errors,
            touched,
          }) => {
            useEffect(() => {
              if (
                specialistsQuery.isSuccess &&
                roomsQuery.isSuccess &&
                !currentEventEdit
              ) {
                if (specialistsQuery?.data?.length > 0) {
                  setFieldValue("userId", specialistsQuery.data[0].id);
                }
                if (roomsQuery?.data?.length > 0) {
                  setFieldValue("roomId", roomsQuery.data[0].id);
                }
              }
            }, [specialistsQuery, roomsQuery]);

            // Ensure fees is always a string when editing
            useEffect(() => {
              if (currentEventEdit && Array.isArray(currentEventEdit.fees)) {
                setFieldValue("fees", currentEventEdit.fees.join(","));
              }
            }, [currentEventEdit, setFieldValue]);

            return (
              <DialogCreate
                onClose={() => {
                  setCurrentEventEdit(undefined);
                  resetForm();
                }}
                open={openDialogCreate}
                setOpen={functionOpenDialogCreate}
                tittle={t("lesson.views.new_class")}
                subTittle={t("lesson.views.creation_calendar")}
                tittleButtonCreate={
                  currentEventEdit ? t("general.edit") : t("general.create")
                }
                tittleButtonCancel={t("general.cancel")}
                OnclickCreate={handleSubmit}
                OnclickCancel={() => {
                  setCurrentEventEdit(undefined);
                  resetForm();
                  functionOpenDialogCreate();
                }}
                isLoading={
                  createLessonResult.isLoading || updateLessonResult.isLoading
                }
                acceptDisabled={
                  createLessonResult.isLoading || updateLessonResult.isLoading
                }
                cancelDisabled={
                  createLessonResult.isLoading || updateLessonResult.isLoading
                }
              >
                <form>
                  <div className="mt-6 mx-2">
                    <div className="space-y-12">
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.caracteristics")}
                            </h2>
                          </div>
                        </div>

                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.name")}
                              span={t("general.mandatory")}
                              name="name"
                              type="text"
                              placeholder={t("lesson.views.name")}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={touched.name && !!errors.name}
                              textError={touched.name && errors.name}
                              value={values.name}
                            />
                          </div>
                          <div className="col-span-full">
                            <Select
                              name="roomId"
                              span={t("general.optional")}
                              selected={roomsQuery?.data?.find(
                                (room: any) => room.id == values.roomId
                              )}
                              setSelected={(selected) =>
                                setFieldValue("roomId", selected.id)
                              }
                              options={roomsQuery?.data}
                              tittle={t("lesson.views.room")}
                            />
                          </div>
                          <div className="col-span-full">
                            <SelectAvatar
                              name="userId"
                              span={t("general.optional")}
                              selected={specialistsQuery?.data?.find(
                                (user: any) => user.id == values.userId
                              )}
                              setSelected={(selected) =>
                                setFieldValue("userId", selected.id)
                              }
                              options={specialistsQuery?.data}
                              tittle={t("lesson.views.specialist")}
                            />
                          </div>
                          <div className="col-span-full">
                            <MultiSelect
                              span={t("general.optional")}
                              selectedOptions={getterFeesResult?.data?.filter(
                                (fee) => {
                                  // Ensure fees is always treated as a string
                                  let feesString = values.fees;
                                  if (Array.isArray(values.fees)) {
                                    feesString = values.fees.join(",");
                                  }

                                  const feesArray = (feesString || "")
                                    .split(",")
                                    .filter(Boolean);

                                  return feesArray.includes(String(fee.id));
                                }
                              )}
                              setSelectedOptions={(selected) => {
                                // Ensure selected is always an array
                                const selectedArray = Array.isArray(selected)
                                  ? selected
                                  : [selected];

                                // Extract fee IDs and join them into a comma-separated string
                                const feeIds = selectedArray
                                  .filter((fee) => fee && fee.id)
                                  .map((fee) => fee.id);

                                // Set the fees field as a comma-separated string
                                setFieldValue("fees", feeIds.join(","));
                              }}
                              options={getterFeesResult?.data ?? []}
                              title={t("lesson.views.fees")}
                              textDescribe={t("lesson.views.no_fee_selected")}
                            />
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.capacity")}
                              span={t("general.mandatory")}
                              name="capacity"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder={t("lesson.views.capacity")}
                              error={touched.capacity && !!errors.capacity}
                              textError={touched.capacity && errors.capacity}
                              value={values.capacity}
                            />
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.expected_attendance")}
                              span={t("general.mandatory")}
                              name="expectedAttendance"
                              type="number"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              placeholder={t(
                                "lesson.views.expected_attendance"
                              )}
                              error={
                                touched.expectedAttendance &&
                                !!errors.expectedAttendance
                              }
                              textError={
                                touched.expectedAttendance &&
                                errors.expectedAttendance
                              }
                              value={values.expectedAttendance}
                            />
                          </div>
                          <div className="col-span-full">
                            <SelectColor
                              span={t("general.mandatory")}
                              selected={colors.find(
                                (option) =>
                                  option?.color == values?.color.toUpperCase()
                              )}
                              setSelected={(selected) => {
                                setFieldValue("color", selected?.color);
                              }}
                              options={colors}
                              tittle={t("lesson.views.color")}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.calendaring")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <CheckBoxDays
                              value={
                                values.day && !checkAllEvents
                                  ? [values.day]
                                  : values.days
                              }
                              onChange={(days: string[]) => {
                                const lastDay = days[days.length - 1];
                                if (values.day && !checkAllEvents) {
                                  setFieldValue("day", lastDay);
                                } else {
                                  setFieldValue("days", days);
                                }
                              }}
                              error={errors.days && touched.days}
                              textError={errors.days}
                            />
                          </div>
                          <div className="col-span-full">
                            <DateRangePicker
                              minDate={
                                currentEventEdit
                                  ? DateTime.fromFormat(
                                      values.startDate,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                  : new Date()
                              }
                              disabled={currentEventEdit && !checkAllEvents}
                              span={t("general.optional")}
                              id="date"
                              label={t("lesson.views.interval_date")}
                              value={{
                                startDate: values.startDate
                                  ? DateTime.fromFormat(
                                      values.startDate,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                  : new Date(),
                                endDate: values.endDate
                                  ? DateTime.fromFormat(
                                      values.endDate,
                                      "yyyy-MM-dd"
                                    ).toJSDate()
                                  : new Date(),
                              }}
                              onDateChange={(startDate, endDate) => {
                                setFieldValue(
                                  "startDate",
                                  DateTime.fromJSDate(startDate).toFormat(
                                    "yyyy-MM-dd"
                                  )
                                );
                                setFieldValue(
                                  "endDate",
                                  DateTime.fromJSDate(endDate).toFormat(
                                    "yyyy-MM-dd"
                                  )
                                );
                              }}
                            />
                          </div>
                          <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                            <InputWithCornerHint
                              label={t("lesson.views.time_init")}
                              span={t("general.mandatory")}
                              name="startTime"
                              type="time"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values.startTime}
                              error={touched.startTime && !!errors.startTime}
                              textError={touched.startTime && errors.startTime}
                            />
                            <InputWithCornerHint
                              label={t("lesson.views.duration")}
                              span={t("general.mandatory")}
                              name="duration"
                              type="number"
                              value={values.duration}
                              error={touched.duration && !!errors.duration}
                              textError={touched.duration && errors.duration}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                          </div>
                          {currentEventEdit && (
                            <div className="col-span-full">
                              <div className="relative flex items-start">
                                <div className="flex h-6 items-center">
                                  <input
                                    checked={checkAllEvents}
                                    onChange={() => {
                                      setCheckAllEvents(!checkAllEvents);
                                    }}
                                    name="all"
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                                    onBlur={handleBlur}
                                  />
                                </div>
                                <div className="ml-3 text-sm leading-6">
                                  <label
                                    htmlFor=""
                                    className="font-medium text-gray-900"
                                  >
                                    Este evento y los posteriores
                                  </label>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </DialogCreate>
            );
          }}
        </Formik>
        {/*FIN DIALOG NUEVA ACTIVIDAD */}

        {/*DIALOG HORAS*/}
        <Formik
          enableReinitialize
          onSubmit={(values: LessonTimesValues, formikHelpers) => {
            updateBranchHours({
              ...values,
              type: "assisteds",
              branchId: id,
            });
            functionOpenDialogTime();
          }}
          initialValues={lessonTimesValues ?? lessonTimesInitialValues}
          validationSchema={lessonTimesValidationSchema}
        >
          {({ handleChange, handleSubmit, values, errors }) => (
            <DialogCreate
              onClose={() => {}}
              open={openDialogTime}
              setOpen={functionOpenDialogTime}
              tittle={t("lesson.views.hours")}
              subTittle={t("lesson.views.creation_hours")}
              tittleButtonCreate={t("general.edit")}
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={functionOpenDialogTime}
              isLoading={updateBranchHourssResult.isLoading}
            >
              <form action="">
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("lesson.views.hours")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.cancellation_time")}
                            span={t("general.mandatory")}
                            name="hours"
                            type="number"
                            placeholder=""
                            onChange={handleChange}
                            error={!!errors.hours}
                            textError={errors.hours}
                            value={values.hours}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.booking_advance")}
                            span={t("general.mandatory")}
                            id="days_access"
                            name="days_access"
                            type="number"
                            placeholder=""
                            onChange={handleChange}
                            error={!!errors.days_access}
                            textError={errors.days_access}
                            value={values.days_access}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.access_time_before_min")}
                            span={t("general.mandatory")}
                            id="time_access"
                            name="time_access"
                            type="number"
                            onChange={handleChange}
                            error={!!errors.time_access}
                            textError={errors.time_access}
                            value={values.time_access}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG HORAS*/}

        {/*DIALOG CALENDARIO*/}
        <Formik
          enableReinitialize
          initialValues={lessonsCalendarInitialValues}
          validationSchema={lesssonsCalendarValidationSchema}
          onSubmit={async (values, formikHelpers) => {
            const formToSend = new FormData();

            if (values.file) {
              formToSend.append("file", values.file);
            }

            await storeCalendarFile({ id, fileStore: formToSend }).unwrap();

            formikHelpers.resetForm();
            functionOpenDialogUpCalendar();
          }}
        >
          {({ setFieldValue, values, handleSubmit, resetForm, errors }) => {
            return (
              <DialogCreate
                open={openDialogUpCalendar}
                setOpen={functionOpenDialogUpCalendar}
                tittle={t("lesson.views.calendar_tittle")}
                subTittle={t("lesson.views.up_calendar")}
                tittleButtonCreate={t("general.save")}
                tittleButtonCancel={t("general.cancel")}
                OnclickCreate={handleSubmit}
                onClose={() => {
                  functionOpenDialogUpCalendar();
                  resetForm();
                }}
                OnclickCancel={() => {
                  functionOpenDialogUpCalendar();
                  resetForm();
                }}
              >
                <form action="">
                  <div className="mt-6 mx-2">
                    <div className="space-y-12">
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.calendar_tittle")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputFilepdf
                              name="file"
                              id="file"
                              span={t("general.mandatory")}
                              label={t("lesson.views.calendar_tittle")}
                              spanButton={t("lesson.views.up_calendar")}
                              description={t("general.format_pdf")}
                              onFileChange={(file) =>
                                setFieldValue("file", file)
                              }
                              tittleDelete={t("general.delete_archive")}
                              onRemoveFile={() => {
                                setFieldValue("file", null);
                              }}
                              selectedFileName={
                                values.file ? values.file.name : null
                              }
                              error={!!errors.file}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </DialogCreate>
            );
          }}
        </Formik>
        {/*FIN DIALOG CALENDARIO*/}

        {/*MODAL TABLE FESTIVOS*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={functionOpenModalFestivos}
          open={openModalFestivos}
          tittleModal={t("lesson.views.festivos")}
          functionButtonTopCreate={functionOpenDialogFestivos}
          textButtonClose={t("general.close")}
          modalClassName="z-50"
        >
          <TableListFestivos
            openModal={functionOpenDialogFestivos}
            optionsFestivos={holidaysQuery.data}
            onDelete={(holiday) => deleteHoliday(holiday)}
            onEdit={(holiday) =>
              setCurrentHolidayEdit({
                ...holiday,
                time_start: holiday.timeStart,
                time_end: holiday.timeEnd,
              })
            }
          />
        </ModalXXL>
        {/*FIN MODAL TABLE FESTIVOS*/}

        {/*DIALOG FESTIVOS*/}
        <Formik
          enableReinitialize
          initialValues={currentHolidayEdit ?? holidaysInitialValues}
          validationSchema={holidaysValidationSchema}
          onSubmit={async (values, formikHelpers) => {
            if (currentHolidayEdit) {
              await updateHoliday({
                ...values,
                branchId: id,
              }).unwrap();
              functionOpenModalFestivos();
              lessonsQuery.refetch();
            } else {
              await createHoliday({
                ...values,
                branchId: id,
              }).unwrap();
              functionOpenModalFestivos();
              lessonsQuery.refetch();
            }

            formikHelpers.resetForm();
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleBlur,
            handleSubmit,
            resetForm,
            values,
            errors,
            touched,
          }) => (
            <DialogCreate
              onClose={() => {
                setCurrentHolidayEdit(null);
                resetForm();
              }}
              open={openDialogFestivos}
              setOpen={functionOpenDialogFestivos}
              tittle={t("lesson.views.festivos")}
              subTittle={t("lesson.views.creation_festivos")}
              tittleButtonCreate={
                currentHolidayEdit ? t("general.edit") : t("general.create")
              }
              isLoading={
                createHolidayResult.isLoading || updateHolidayResult.isLoading
              }
              acceptDisabled={
                createHolidayResult.isLoading || updateHolidayResult.isLoading
              }
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => {
                functionOpenDialogFestivos();
                resetForm();
              }}
            >
              <form onSubmit={handleSubmit}>
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("lesson.views.caracteristics")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.festivo")}
                            span={t("general.mandatory")}
                            id="description"
                            name="description"
                            type="text"
                            placeholder={t("lesson.views.festivo")}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.description && !!errors.description}
                            textError={
                              touched.description && errors.description
                            }
                            value={values.description}
                          />
                        </div>
                        <div className="col-span-full">
                          <Select
                            name="type"
                            selected={optionSelectFestivos.find(
                              (festivo) => festivo.id == values.type
                            )}
                            setSelected={(selected) =>
                              setFieldValue("type", selected.id)
                            }
                            options={optionSelectFestivos}
                            tittle={t("lesson.views.type")}
                            span={t("general.mandatory")}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3 border-b border-gray-200">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("lesson.views.calendaring")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.date")}
                            span={t("general.mandatory")}
                            id="date"
                            name="date"
                            type="date"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.date && !!errors.date}
                            textError={touched.date && errors.date}
                            value={values.date}
                          />
                        </div>
                        <div className="col-span-full grid grid-cols-2 gap-8 place-content-center">
                          <InputWithCornerHint
                            label={t("lesson.views.time_init")}
                            span={t("general.mandatory")}
                            id="time_start"
                            name="time_start"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.time_start && !!errors.time_start}
                            textError={errors.time_start}
                            value={values.time_start}
                          />
                          <InputWithCornerHint
                            label={t("lesson.views.time_end")}
                            span={t("general.mandatory")}
                            id="time_end"
                            name="time_end"
                            type="time"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.time_end && !!errors.time_end}
                            textError={errors.time_end}
                            value={values.time_end}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG FESTIVOS*/}

        {/*MODAL SALAS*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={functionOpenModalSala}
          open={openModalSala}
          tittleModal={t("lesson.views.rooms")}
          functionButtonTopCreate={functionOpenDialogSala}
          textButtonClose={t("general.close")}
          canCreate={can(
            Permission.BRANCH_ACCESS_CREATE_EDIT_ROOMS_IN_ACTIVITIES
          )}
          modalClassName="z-50"
        >
          <TableListSalas
            optionsSalas={roomsQuery?.data}
            onDelete={(room) => deleteRoom(room)}
            onEdit={(room) => setCurrentRoomEdit(room)}
            canEdit={can(
              Permission.BRANCH_ACCESS_CREATE_EDIT_ROOMS_IN_ACTIVITIES
            )}
            canDelete={can(Permission.BRANCH_ACCESS_DELETE_SPACE_BONUSES)}
          />
        </ModalXXL>
        {/*FIN MODAL SALAS*/}

        {/*DIALOG CREATE SALAS */}
        <Formik
          enableReinitialize
          validationSchema={createRoomValidationSchema}
          initialValues={currentRoomEdit ?? createRoomInitialValues}
          onSubmit={(values: CreateRoomValues, formikHelpers) => {
            if (currentRoomEdit) {
              setCurrentRoomEdit(undefined);
              updateRoom({
                ...values,
                id: currentRoomEdit.id,
              });
            } else {
              createRoom({ ...values, branchId: id });
            }
            formikHelpers.resetForm();
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            resetForm,
            errors,
            setFieldValue,
          }) => (
            <DialogCreate
              onClose={() => {
                setCurrentRoomEdit(undefined);
                resetForm();
              }}
              open={openDialogSala}
              setOpen={functionOpenDialogSala}
              tittle={t("lesson.views.directed_activities_rooms")}
              subTittle={
                currentRoomEdit
                  ? t("lesson.views.edited_rooms")
                  : t("lesson.views.creating_rooms")
              }
              tittleButtonCreate={
                currentRoomEdit ? t("general.edit") : t("general.create")
              }
              tittleButtonCancel={t("general.cancel")}
              OnclickCreate={handleSubmit}
              OnclickCancel={() => {
                functionOpenDialogSala();
                resetForm();
              }}
            >
              <form>
                <div className="mt-6 mx-2">
                  <div className="space-y-12">
                    <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                      <div className="flex items-center justify-center h-full text-center">
                        <div>
                          <h2 className="text-base font-semibold leading-7 text-gray-900">
                            {t("lesson.views.rooms")}
                          </h2>
                        </div>
                      </div>
                      <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.name")}
                            span={t("general.mandatory")}
                            name="name"
                            type="text"
                            placeholder={t("lesson.views.name")}
                            onChange={handleChange}
                            value={values.name}
                            error={!!errors.name}
                            textError={errors.name}
                          />
                        </div>
                        <div className="col-span-full">
                          <InputWithCornerHint
                            label={t("lesson.views.description")}
                            span={t("general.mandatory")}
                            id="description"
                            name="description"
                            type="text"
                            placeholder={t("lesson.views.description")}
                            onChange={handleChange}
                            value={values.description}
                            error={!!errors.description}
                            textError={errors.description}
                          />
                        </div>
                        <div className="col-span-full">
                          <SelectColor
                            options={colors}
                            span={t("general.mandatory")}
                            tittle={t("lesson.views.color")}
                            selected={colors.find(
                              (option) => option?.color == values?.color
                            )}
                            setSelected={(selected) => {
                              setFieldValue("color", selected?.color);
                            }}
                            error={!!errors.color}
                            textError={errors.color}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </DialogCreate>
          )}
        </Formik>
        {/*FIN DIALOG CREATE SALAS */}

        {/*MODAL GRUPOS*/}
        <ModalXXL
          Close={functionOpenModalGrupos}
          open={openModalGrupos}
          tittleModal={t("lesson.views.groups")}
          textButtonClose={t("general.close")}
          modalClassName="z-50"
        >
          <TableListGrupos
            editGroups={(group) => {
              setCurrentGroupEdit(group);
              functionOpenDialogEditGrupos();
            }}
            optionsGroup={lessonGroupsQuery?.data}
          />
        </ModalXXL>
        {/*FIN MODAL GRUPOS*/}

        {/*DIALOG EDIT GRUPOS*/}
        <Formik
          enableReinitialize
          onSubmit={async (values, formikHelpers) => {
            try {
              await handleUpdateLessonsGroup(values);
              setOpenDialogEditGrupos(false);
              functionOpenModalGrupos();
              formikHelpers.resetForm();
            } catch (error) {
              console.log(error);
            }
          }}
          initialValues={{
            description: currentGroupEdit ? currentGroupEdit?.description : "",
            file: currentGroupEdit?.pathFileImage
              ? `${DOMAIN}/${currentGroupEdit.pathFileImage}`
              : undefined,
          }}
        >
          {({
            handleChange,
            handleSubmit,
            values,
            errors,
            resetForm,
            setFieldValue,
          }) => {
            return (
              <DialogCreate
                isLoading={updateLessonsGroupResult.isLoading}
                onClose={() => {
                  functionOpenDialogEditGrupos();
                  resetForm();
                }}
                open={openDialogEditGrupos}
                setOpen={functionOpenDialogEditGrupos}
                tittle={t("lesson.views.group")}
                subTittle={t("lesson.views.edit_group")}
                tittleButtonCreate={t("general.edit")}
                tittleButtonCancel={t("general.cancel")}
                OnclickCreate={handleSubmit}
                OnclickCancel={() => {
                  functionOpenDialogEditGrupos();
                  resetForm();
                }}
              >
                <form>
                  <div className="mt-6 mx-2">
                    <div className="space-y-12">
                      <div className="grid grid-cols-1 gap-x-8 gap-y-10 pb-12 md:grid-cols-3">
                        <div className="flex items-center justify-center h-full text-center">
                          <div>
                            <h2 className="text-base font-semibold leading-7 text-gray-900">
                              {t("lesson.views.groups")}
                            </h2>
                          </div>
                        </div>
                        <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 md:col-span-2">
                          <div className="col-span-full">
                            <InputFile
                              id="file"
                              name="file"
                              label={t("lesson.views.thumbnail")}
                              span=""
                              spanButton={t("general.up_image")}
                              description={t("general.format_image")}
                              selectedImage={values.file}
                              error={!!errors.file}
                              onFileChange={(file) =>
                                setFieldValue("file", file)
                              }
                              onRemoveImage={() => {
                                setFieldValue("file", null);
                              }}
                              tittleDelete={t("general.delete_image")}
                            />
                            <p className="text-sm text-gray-400 mt-1 text-center">
                              {t("lesson.views.thumbnail_description")}
                            </p>
                          </div>
                          <div className="col-span-full">
                            <InputWithCornerHint
                              label={t("lesson.views.description")}
                              span=""
                              id=""
                              name="description"
                              type="text"
                              placeholder={t("lesson.views.description")}
                              onChange={handleChange}
                              error={!!errors.description}
                              textError={errors.description}
                              value={values.description}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </DialogCreate>
            );
          }}
        </Formik>
        {/*DIALOG EDIT GRUPOS */}

        {/*MODAL XXL*/}
        <ModalXXL
          onClickCreate={() => {}}
          Close={() => setCurrentEvent(undefined)}
          open={!!currentEvent}
          tittleModal={t("lesson.views.activity")}
          textButtonClose={t("general.close")}
          functionButtonTopCreate={functionOpenModalEnrollUserActivity}
          functionButtonDelete={functionOpenModalDeleteEvent}
          functionButtonEdit={() => {
            setCurrentEventEdit(currentEvent);
            setOpenDialogCreate(true);
          }}
          //canEnrollUserToLesson={can(Permission.BRANCH_ACCESS_CREATE_ACTIVITY)}
          canEdit={can(Permission.BRANCH_ACCESS_EDIT_ACTIVITIES)}
          canDelete={can(Permission.BRANCH_ACCESS_DELETE_ACTIVITIES)}
        >
          <div className="flex flex-col sm:flex-row">
            {/* Columna Izquierda */}
            <div className="w-full sm:w-1/2 p-4">
              <div>
                <div className="px-4 sm:px-0">
                  <h3 className="text-base font-semibold leading-7 text-gray-900">
                    {currentEvent?.name}
                  </h3>
                  <p className="mt-1 max-w-2xl text-sm leading-6 text-gray-500">
                    {currentEvent?.description}
                  </p>
                </div>
                <div className="mt-6 border-t border-gray-100">
                  <dl className="divide-y divide-gray-100">
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.ocupation")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {currentEvent?.expectedAttendance}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.date_duration")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {currentEvent?.date} ({currentEvent?.duration} min)
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.specialist")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {currentEvent?.user?.name}
                      </dd>
                    </div>
                    <div className="px-4 py-6 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                      <dt className="text-sm font-medium leading-6 text-gray-900">
                        {t("lesson.views.room")}
                      </dt>
                      <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                        {currentEvent?.room?.name}
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>

            {/* Columna Derecha */}
            <div className="w-full sm:w-1/2 p-4">
              <TableListUsersActivitys
                users={currentEvent?.reservations?.map(({ user }) => user)}
                onClickEmpty={functionOpenModalEnrollUserActivity}
              />
            </div>
          </div>
        </ModalXXL>
        {/*FIN MODAL XXL */}

        {/* MODAL ENROLL USER ACTIVITY XXL */}

        <Formik
          initialValues={{
            user: null,
            all: false,
          }}
          validationSchema={Yup.object({
            user: Yup.string()
              .min(1, FIELD_REQUIRED_MESSAGE)
              .required(FIELD_REQUIRED_MESSAGE),
          })}
          validateOnMount={false}
          onSubmit={async (values, formikHelpers) => {
            try {
              await handleEnrollUserActivity(values);
              formikHelpers.resetForm();
            } catch (error) {
              console.log(error);
              functionOpenModalEnrollUserActivity();
              formikHelpers.resetForm();
            }
          }}
        >
          {({
            handleSubmit,
            isValid,
            values,
            errors,
            touched,
            handleBlur,
            resetForm,
            setFieldValue,
          }) => {
            return (
              <Modal
                Close={() => {
                  functionOpenModalEnrollUserActivity();
                  resetForm();
                }}
                open={openModalEnrollUserActivity}
                tittleModal={"Agregar usuario"}
                textButtonClose={t("general.close")}
                textButtonCreate={t("general.save")}
                onClickCreate={handleSubmit}
                disabledCreated={enrollUserLessonResult.isLoading || !isValid}
                loader={enrollUserLessonResult.isLoading}
              >
                <div>
                  <div className="col-span-full grid grid-cols-1 place-content-center mt-4">
                    <InputWithSelectHint
                      name="user"
                      tittle={t("lesson.views.enroll_user_activity")}
                      span={t("general.mandatory")}
                      setSelected={(user) => {
                        setFieldValue("user", user?.id);
                      }}
                      selected={users.find((user) => user.id === values.user)}
                      type="text"
                      onQueryChange={(search) =>
                        debouncedFetchDataUsers(search)
                      }
                      options={users}
                      error={errors.user && touched.user}
                      textError={errors.user as string}
                    />
                  </div>

                  <div className="col-span-full mt-3">
                    <div className="relative flex items-start">
                      <div className="flex h-6 items-center">
                        <input
                          id="all"
                          checked={checkAllEvents}
                          onChange={() => {
                            setCheckAllEvents(!checkAllEvents);
                            setFieldValue("all", !checkAllEvents);
                          }}
                          name="all"
                          type="checkbox"
                          className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
                          onBlur={handleBlur}
                        />
                      </div>
                      <div className="ml-3 text-sm leading-6">
                        <label
                          htmlFor="all"
                          className="font-medium text-gray-900"
                        >
                          Este evento y los posteriores
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </Modal>
            );
          }}
        </Formik>

        {/*MODAL DELETE EVENT XXL*/}
        <Modal
          Close={functionOpenModalDeleteEvent}
          open={openModalDeleteEvent}
          tittleModal={""}
          onClickCreate={handleDeleteLesson}
          textButtonCreate={t("general.delete")}
          textButtonClose={t("general.close")}
        >
          <div>
            <h2 className="text-2xl font-semibold">Cuidado</h2>
            <div className="mt-4 ">
              <p>
                Si deseas eliminar todos los eventos posteriores que pertenecen
                a esta misma actividad dirigida
              </p>
            </div>
            <div className="mt-4 flex items-center gap-2">
              <label
                className="flex items-center cursor-pointer select-none"
                htmlFor="deleteAllEventsCheckbox"
              >
                <Input
                  id="deleteAllEventsCheckbox"
                  checked={deleteAllEvents}
                  onChange={() => setDeleteAllEvents(!deleteAllEvents)}
                  type="checkbox"
                  className="flex"
                  label=""
                  aria-checked={deleteAllEvents}
                />
                <span className="ml-2">
                  Eliminar este evento y los posteriores
                </span>
              </label>
            </div>
          </div>

          <div className="mt-4">
            <span>Está seguro que desea eliminar?</span>
          </div>
        </Modal>

        <AlertWarningButtons
          onClose={() => setShowModalWarningCreateLessonForce(false)}
          open={showModalWarningCreateLessonForce}
          title="Confirmar Actividad"
          message="¿Estás seguro de que deseas crear la actividad? Esta actividad se solapa con otras actividades."
          primaryButtonText="Continuar"
          secondaryButtonText="Cancelar"
          onPrimaryButtonClick={handleCreateLessonForce}
          onSecondaryButtonClick={() => {
            setShowModalWarningCreateLessonForce(false);
          }}
          isLoading={createLessonResult.isLoading}
        />
      </div>
      {filters ? (
        <>
          <FiltersCalendar
            filtersOpen={filtersOpen}
            selectedGroups={selectedGroups}
            setSelectedGroups={setSelectedGroups}
            options={lessonGroupsQuery?.data}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
